import {
  QUIZ,
  QUIZ_SUCCESS,
  QUIZ_FAILURE,
  ATTEMPT_QUIZ,
  ATTEMPT_QUIZ_SUCCESS,
  ATTEMPT_QUIZ_FAILURE,
  SET_INDEX,
  RESET_INDEX,
  QUIZ_FINISHED,
  RESET_QUIZ,
  SET_POINTS
} from "./types"

export const getQuiz = (data,meeting_id) => ({
  type: QUIZ,
  data,
  meeting_id
})

export const getQuizSuccess = data => ({
  type: QUIZ_SUCCESS,
  data
})

export const getQuizFailure = error => ({
  type: QUIZ_FAILURE,
  error
})

export const attemptQuiz = (data, ref, len, nextIndex) => ({
  type: ATTEMPT_QUIZ,
  data,
  ref,
  len,
  nextIndex
})

export const attemptQuizSuccess = (data, ref, len) => ({
  type: ATTEMPT_QUIZ_SUCCESS,
  data,
  ref,
  len
})

export const attemptQuizFailure = error => ({
  type: ATTEMPT_QUIZ_FAILURE,
  error
})

export const setIndex = data => ({
  type: SET_INDEX,
  data
})

export const resetIndex = data => ({
  type: RESET_INDEX,
  data
})

export const quizFinished = data => ({
  type: QUIZ_FINISHED,
  data
})

export const resetQuiz = () =>({
  type: RESET_QUIZ
})

export const setTotalPoints = data => ({
  type: SET_POINTS,
  data
})